import React, { useContext, useState } from 'react';
import Header from '../components/interstitial/Header';
import {
  Container,
  OuterWrapper,
  CardWrapper,
  InterstitialCard,
  Footer,
} from '../components/interstitial/styled';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { EditorContext } from '../../../utils/contexts';
import { FORM_LAYOUTS } from '../constants';
import { FORM_LAYOUT_META as LAYOUT_META } from '../forms/constants';

export default function FormLayoutSelection() {
  const history = useHistory();
  const match = useRouteMatch();
  const { dispatch, settings } = useContext(EditorContext);
  const [, setActive] = useState(settings.type);

  const onSelect = (layout) => {
    setActive(layout);
    dispatch({ type: 'update_type', payload: layout });
    const pathParts = window.location.pathname.split('/');
    const siteId = match.params.siteId || pathParts[pathParts.indexOf('sites') + 1];

    try {
      window.analytics?.track('Form Layout Selected', { layout, site_id: siteId });
    } catch (_) {}

    history.push(`/sites/${siteId}/forms/new/design`);
  };

  return (
    <div>
      <Header text="CHOOSE LAYOUT" />
      <Container>
        <h5>How should your form be displayed?</h5>
        <p>Select a layout for your form. You can change this later.</p>
        <OuterWrapper>
          <CardWrapper>
            {FORM_LAYOUTS.slice(0, 2).map((layout) => (
              <InterstitialCard
                key={layout}
                name={layout}
                title={layout === 'Takeover' ? 'Page Takeover' : layout}
                highlight={layout === 'Modal' ? 'Recommended' : undefined}
                onClick={onSelect}
              >
                {LAYOUT_META[layout]?.description}
              </InterstitialCard>
            ))}
          </CardWrapper>
          <CardWrapper>
            {FORM_LAYOUTS.slice(2).map((layout) => (
              <InterstitialCard
                key={layout}
                name={layout}
                title={layout === 'Takeover' ? 'Page Takeover' : layout}
                onClick={onSelect}
              >
                {LAYOUT_META[layout]?.description}
              </InterstitialCard>
            ))}
          </CardWrapper>
        </OuterWrapper>
        <Footer />
      </Container>
    </div>
  );
}
